import React from 'react';
import Tag from './ui/Tag';

/** A shelf section's code as a pill: the kit's code tag, bold so a picker finds it at a glance. */
const SectionChip: React.FC<{ code: string }> = ({ code }) => (
  <Tag variant="code" className="font-bold">{code}</Tag>
);

export default SectionChip;
